<!--
 * @Description: 值班表
 * @Author: PF
 * @Date: 2023-09-18 17:13:25
 * @LastEditors: PF
 * @LastEditTime: 2024-09-27 13:54:52
-->
<template>
  <div>
    <el-dialog class="wp70 hp80" :model-value="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <div>
            <span class="header-title">值班信息</span>
          </div>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <div class="button-box">
              <el-tabs v-model="zhiBanActive" @tab-change="handleChange">
                <el-tab-pane label="我的值班" name="wdzb"></el-tab-pane>
                <el-tab-pane label="当前值班信息" name="zbxx"></el-tab-pane>
                <el-tab-pane label="值班表" name="zbb"></el-tab-pane>
              </el-tabs>
            </div>
          </el-header>
          <el-main>
            <el-table v-if="zhiBanActive==='wdzb'" :data="wdzbTable" height="100%" border stripe>
              <el-table-column label="值班位置" prop="zbwz" align="center" show-overflow-tooltip />
              <el-table-column label="值班时段" prop="zbsd" width="90" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span v-for="(item, index) in zbsdData" :key="index">
                    <span v-if="scope.row.zbsd === item.value">{{item.name}}</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="值班时间" prop="zbksrq" width="200" align="center" show-overflow-tooltip>
                <template #default="scope">
                  {{ scope.row.zbrq }}
                  {{ scope.row.zbkssj }}
                  <span v-if="scope.row.zbkssj && scope.row.zbkssj"> 至 </span>
                  {{ scope.row.zbkssj }}
                </template>
              </el-table-column>
            </el-table>

            <el-table v-if="zhiBanActive==='zbxx'" :data="zbxxTable" height="100%" border stripe>
              <el-table-column label="值班内容" prop="zbnrmc" align="center" show-overflow-tooltip />
              <el-table-column label="值班人" prop="zbryxm" align="center" show-overflow-tooltip />
              <el-table-column v-if="zhiBanActive==='zbb'" label="值班日期" prop="zbrq" align="center" show-overflow-tooltip />
              <el-table-column label="值班位置" prop="zbwz" align="center" show-overflow-tooltip />
              <el-table-column label="值班时段" prop="zbsd" width="90" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span v-for="(item, index) in zbsdData" :key="index">
                    <span v-if="scope.row.zbsd === item.value">{{item.name}}</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="值班时间" prop="zbsd" align="center" show-overflow-tooltip>
                <template #default="scope">
                  {{ scope.row.zbkssj }}<span v-if="scope.row.zbkssj && scope.row.zbjssj">-</span>{{ scope.row.zbjssj }}
                </template>
              </el-table-column>
            </el-table>

            <el-table v-if="zhiBanActive==='zbb'" :data="zbbTable" height="100%" border stripe>
              <el-table-column label="值班类别" prop="zblbmc" align="center" show-overflow-tooltip />
              <el-table-column label="值班内容" prop="zbnrmc" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span style="color: #409EFF;cursor: pointer;" @click="openTc='zhibanbiao'; row=scope.row">{{scope.row.zbnrmc}}</span>
                </template>
              </el-table-column>
              <el-table-column label="值班时间" prop="zbksrq" width="200" align="center" show-overflow-tooltip>
                <template #default="scope">
                  {{ scope.row.zbksrq }}
                  <span v-if="scope.row.zbksrq && scope.row.zbjsrq"> 至 </span>
                  {{ scope.row.zbjsrq }}
                </template>
              </el-table-column>
            </el-table>
          </el-main>
        </el-container>
      </div>
    </el-dialog>
  </div>
  <zhibanbiao v-if="openTc === 'zhibanbiao'" :open="openTc" :row="row" @openReturn="openReturnDetail" />
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { actionPost, loadSelect, homeCloseWindow } from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo.js'
import zhibanbiao from '@/components/home/zhibanxinxi/zhibanbiaodetail.vue' // 值班表详情

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])


const openTc = ref('') // 打开弹窗
const openReturnDetail = (val) => {
  openTc.value = val // 关闭弹窗或关闭后打开新弹窗
}
// 弹窗
const openList = ref(false)

// 值班信息 BEGIN
// 加载 值班时段 下拉框
const zbsdData = ref([])
const zhiBanActive = ref('wdzb') // 值班选中
const handleChange = (val) => {
  switch (val) {
    case 'wdzb':
      initWdzb()
      break
    case 'zbxx':
      initZbxx()
      break
    case 'zbb':
      initZbb()
      break
  }
}
// 我的值班
const wdzbTable = ref([])
const initWdzb = async () => {
  const data = { order: 'zbrq', sort: 'desc' }
  actionPost({
    url: '/api/v2/bangong/zhibanrenyuanjilu/wodelist',
    data: data
  }).then((res) => {
    if (res.code === 200) {
      wdzbTable.value = res.data || []
    } else {
      warningPrompt(res.message)
    }
  })
}
// 当前值班信息
const zbxxTable = ref([])
const initZbxx = async () => {
  const data = { order: 'zbnrmc', sort: 'desc' }
  actionPost({
    url: '/api/v2/bangong/zhibanrenyuanjilu/dangqianzhiban',
    data: data
  }).then((res) => {
    if (res.code === 200) {
      zbxxTable.value = res.data || []
    } else {
      warningPrompt(res.message)
    }
  })
}
// 值班表
const zbbTable = ref([])
const initZbb = async () => {
  const data = { order: 'zbnrmc', sort: 'desc' }
  actionPost({ url: '/api/v2/bangong/zhibanrenwu/list', data: data }).then(
    (res) => {
      if (res.code === 200) {
        zbbTable.value = res.data || []
      } else {
        warningPrompt(res.message)
      }
    }
  )
}
// 值班信息 END
watch(
  () => props.open,
  () => {
    if (props.open === 'zhibanxinxi') {
      openList.value = true
      loadSelect({
        url: '/api/v2/bangong/zhibanneirong/zhibanshiduan',
        data: zbsdData
      })
      initWdzb()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)

</script>
<style lang="less" scoped>
ul {
  display: flex;
  flex-wrap: wrap;
  li {
    margin-right: 15px;
    margin-bottom: 5px;
    .title {
      color: #000;
    }
  }
}
:deep(.el-tabs__header) {
  margin-bottom: 0px;
}
:deep(.el-card) {
  height: 100%;
}
:deep(.el-card__body) {
  height: 100%;
  overflow: auto;
}
:deep(.search-box){
 justify-content: space-between !important;
}

</style>
